import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Check, ArrowRight } from "lucide-react";

export default function Rooms() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    api.get("/rooms").then((r) => setRooms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="grain min-h-screen relative">
      <Navbar />
      <section className="px-6 md:px-12 lg:px-20 pt-20 pb-10 relative z-10">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D90429] mb-3">Our Studio</p>
        <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tighter max-w-3xl">
          Where your sound comes to life.
        </h1>
      </section>

      <section className="px-6 md:px-12 lg:px-20 py-10 relative z-10 space-y-10">
        {rooms.map((room, i) => (
          <motion.div key={room.room_id}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-white/10 bg-[#121212] overflow-hidden">
            <div className={`aspect-[16/11] overflow-hidden ${i % 2 ? "lg:order-2" : ""}`}>
              <img src={room.image} alt={room.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <p className="text-xs uppercase tracking-[0.2em] text-[#D90429] mb-3">{room.tagline}</p>
              <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight">{room.name}</h2>
              <p className="text-[#A0A0A0] mt-4 leading-relaxed">{room.description}</p>
              <div className="grid grid-cols-2 gap-3 mt-6">
                {room.features.map((f) => (
                  <div key={f} className="flex items-center gap-2 text-sm text-white/80">
                    <Check className="h-4 w-4 text-[#D90429]" /> {f}
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-between mt-8 pt-6 border-t border-white/10">
                <div>
                  <span className="font-display text-3xl font-bold">RON {room.price_per_hour}</span>
                  <span className="text-[#A0A0A0] text-sm">/hr · up to {room.capacity}</span>
                </div>
                <Link to="/book" data-testid={`rooms-book-${room.room_id}`}
                  className="bg-[#D90429] hover:bg-[#ED2939] text-white px-7 py-3 font-bold uppercase tracking-wide text-sm transition-all hover:-translate-y-1 inline-flex items-center gap-2">
                  Book <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </section>
      <Footer />
    </div>
  );
}
